<script>

  import util from './SgsUtils'

  export default{
    props: [
      "attr", "fieldValue", "rules", "label",
      "showHint", "hintValue", "moduleType"
    ],
    methods: {
      getPrefix: function(){
        if (this.attr != undefined) {
          if (this.attr.prefix != undefined && this.attr.prefix != ""){
            return this.attr.prefix;
          }
        }
      },
      getSufix: function(){
        if (this.attr != undefined) {
          if (this.attr.sufix != undefined && this.attr.sufix != "")
            return this.attr.sufix;
        }
      },
      getMaxSize: function(){
        if (this.attr != undefined) {
          if (this.attr.maxSize != undefined)
            return this.attr.maxSize
        }
      },
      getMinSize: function () {
        if (this.attr != undefined) {
          if (this.attr.minSize != undefined)
            return this.attr.minSize
        }
      },
      callBusinessRuleFocus: function() {
        if (this.attr.eventOnFocus) {
          this.$emit('callBusinessRule', this.attr.eventOnFocus);
        }
      },
      callBusinessRuleBlur: function() {
        if (this.attr.eventOnBlur) {
          this.$emit('callBusinessRule', this.attr.eventOnBlur);
        }
      },
      mountPosition: function() {
        let objectToReturn = {
          lat: 0,
          lng: 0
        };
        let lat = this.position.lat;
        let lng = this.position.lng;

        if (lat && lng) {
          objectToReturn.lat = parseFloat(lat);
          objectToReturn.lng = parseFloat(lng);

          this.showMap = true;
        }

        return objectToReturn;
      }

    },
    watch: {
      "position.lat": function(newValue) {
        this.updateFieldValue = this.position;
      },
      "position.lng": function(newValue) {
        this.updateFieldValue = this.position;
      },
      fieldValue: function(val) {
        if(typeof val === 'string' && val !== null && val !== "") {
          this.position = JSON.parse(val);
        }
      },
      position: function(newValue, oldValue) {
        if (newValue.lat !== "" && newValue.lng !== "") {
          this.mountPosition();
        }
      }
    },
    data () {
      return {
        position: {
          lat: "",
          lng: ""
        },
        showMap: false
      }
    },
    computed: {
      updateFieldValue: {
        get: function() {
          if(typeof this.fieldValue === 'string' && this.fieldValue !== null && this.fieldValue !== "") {
            this.position = JSON.parse(this.fieldValue);
          }
          return this.fieldValue;
        },
        set: function(newValue) {
          this.$emit('updateFieldValue', this.attr.columnName, newValue);
        }
      },
      resolveStyle: function () {
        let height = 400;

        if (this.attr.height) {
          height = this.attr.height;
        }

        return "width: 100%; height: " + height + "px";
      },
      _position: function() {
        return this.mountPosition();
      }
    },
    mounted () {
      if (
        typeof this.fieldValue === 'string' &&
        this.fieldValue !== null && this.fieldValue !== ""
      ) {
        this.position = JSON.parse(this.fieldValue);
      }
    },
    created() {
      util.resolveRules(this.attr, this.rules);
      if(this.rules) {
        this.rules[this.attr.columnName].push({
          validator: (rules, value, callback) => {
            if(value){

              let lat = parseFloat(value.lat);
              let lng = parseFloat(value.lng);

              if ((lat && !lng) || (!lat && lng)) {
                callback(new Error(this.$t('bothFieldsAreRequired')));
              } else if (this.attr.required && !(value.lat && value.lng)) {
                callback(new Error(this.$t('pleaseFillInTheField')));
              }
            }
            callback();
          },
          trigger: 'blur'
        });
      }
    }
  }
</script>

<template>
  <div>

    <el-popover
      ref="popover"
      v-show="showHint"
      placement="top-start"
      width="200"
      trigger="hover"
      :content="hintValue">
    </el-popover>

    <el-form-item label="temp" :prop="attr.columnName" v-if="moduleType === 'form'">

      <span slot="label">
        {{label}} <i v-if="showHint && moduleType === 'form'" class="glyphicon glyphicon-question-sign" v-popover:popover />
      </span>

      <div class="row">
        <div class="col-md-6">
          <el-input
            :placeholder="$t('latitude')"
            v-model="position.lat">
          </el-input>
        </div>
        <div class="col-md-6">
          <el-input
            :placeholder="$t('longitude')"
            v-model="position.lng">
          </el-input>
        </div>
      </div>

    </el-form-item>
    <div v-if="moduleType === 'show' && showMap">
      <label>{{label}}</label>
      <p>
        <span>
          <gmap-map
            :center="_position"
            :zoom="15"
            :style="resolveStyle" >
            <gmap-marker
              :position="_position"
            ></gmap-marker>
          </gmap-map>
        </span>
      </p>
    </div>
    <span v-if="moduleType === 'list' && showMap">

      <gmap-map
        :center="_position"
        :zoom="15"
        :style="resolveStyle" >
        <gmap-marker
          :position="_position"
        ></gmap-marker>
      </gmap-map>
    </span>
  </div>
</template>



// WEBPACK FOOTER //
// SgsRenderMap.vue?60173e93